module.exports = __webpack_public_path__ + "static/media/15.86df4f96.svg";